import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { api } from '../lib/api';

/**
 * Qué catálogos de la clínica faltan por configurar (GET /api/catalogos/pendientes).
 *
 * Las marcas, los tratamientos de las campañas, las plantillas y el
 * vocabulario del equipo viven en la base, no en el código: en una
 * instalación nueva están vacíos y cada función que depende de uno se queda
 * quieta en vez de inventar. Aquí se dice qué falta y dónde se rellena. Si
 * no falta nada, no se enseña nada.
 */
export default function CatalogosPendientes() {
  const [faltan, setFaltan] = useState([]);
  useEffect(() => {
    let vivo = true;
    api.get('/api/catalogos/pendientes')
      .then((r) => {
        const filas = Array.isArray(r?.data?.catalogos) ? r.data.catalogos : [];
        if (vivo) setFaltan(filas.filter((f) => f.falta));
      })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);
  if (!faltan.length) return null;
  return (
    <div className="mb-6 rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900"
      data-testid="catalogos-pendientes" role="status">
      <div className="flex items-center gap-2 font-medium mb-2">
        <AlertTriangle className="w-4 h-4" aria-hidden="true" />
        Falta configurar {faltan.length === 1 ? 'un catálogo' : `${faltan.length} catálogos`} de la clínica
      </div>
      <ul className="space-y-1">
        {faltan.map((f) => (
          <li key={f.clave} data-testid={`catalogo-pendiente-${f.clave}`}>
            <span className="font-medium">{f.nombre}</span>
            {f.detalle ? ` — ${f.detalle}` : ''}
            {f.donde ? <span className="text-amber-800"> ({f.donde})</span> : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
